/* eslint-disable import/prefer-default-export */
import InputContainerDefault from '@deprecated-ui/common/InputForm';
import color from '@deprecated-ui/_style/color';
import styled, { css } from 'styled-components';

interface IWrapper {
  disabled?: boolean;
}

export const InputFormWrapper = styled.div<IWrapper>`
  position: relative;

  button.btn-toggle {
    background: transparent;
    border: none;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
    z-index: 1;
  }

  button.btn-toggle img {
    width: 16px;
    height: 16px;

    margin-top: 6px;
  }

  input:disabled {
    background-color: ${color.light} !important;
    color: #858585;
  }

  input:disabled + div {
    height: 0;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      span > div {
        margin-bottom: -10px;
      }
    `}
`;

interface IInputContainer {
  error: boolean;
  isPassword: boolean;
}

export const InputContainer = styled(InputContainerDefault).attrs({
  p: '0',
})<IInputContainer>`
  margin-top: 36px;

  label {
    font-size: 14px;
  }

  input {
    &::placeholder {
      font-family: 'ProximaNovaLt';
    }
    font-size: 18px;
    color: ${color.highempahis};
    width: 100% !important;
    font-family: 'ProximaNovaLt';

    ${({ isPassword }) =>
    isPassword &&
      css`
        width: calc(100% - 30px) !important;
      `}
  }

  input ~ label {
    font-size: 14px;
  }

  input:not(:placeholder-shown) ~ label {
    color: ${color.highempahis};
  }

  input:focus ~ label {
    color: ${color.primary};
  }

  input:not(:placeholder-shown) ~ label,
  input:focus ~ label {
    font-family: 'ProximaNovaBd';
    font-size: 12px !important;
    top: -24px !important;

    ${({ error }) =>
    error &&
      css`
        color: ${color.sunsetOrange};
      `}
  }
`;

export const TextWarningContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
`;
